<section class="p-2 p-md-4">


    <div *ngIf="unidade || cliente" class="card mb-4">
      <div class="col-12 p-3">
          <label for="pesquisaUnidade">{{cliente ? 'Cliente' : 'Unidade'}} </label>
          <div class="d-flex align-items-center autocomplete-container">
            <input
              [inputFormatter]="inputUnidadeFormat"
              (selectItem)="addFiltroUnidade($event)"
              [(ngModel)]="unidadeSelecionada"
              [ngbTypeahead]="pesquisaUnidade"
              [resultTemplate]="rt_unidade" id="pesquisaUnidade"
              type="text" class="form-control">

            <button *ngIf="unidadeSelecionada" (click)="removeFiltroUnidade()"
            class="btn btn-xs btn-danger btn-icon">
              <i class="mdi mdi-close"></i>
            </button>

          </div>
        <ng-template #rt_unidade let-r="result" let-t="term">
          <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
        </ng-template>
      </div>
    </div>

    <div *ngIf="listaUsuarios.length==0" class="card">
      <div class="row">
        <div class="f-16 text-muted card-body">{{idUnidade==null ? 'Selecione uma unidade' : 'Nenhum usuário foi encontrado'}}</div>
        <div class="card-body" *ngIf="usuario.permissoes.administrador">
          <button (click)="adicionarUsuario()" class="btn btn-sm btn-success btn-icon w-100">
            <i class="mdi mdi-plus"></i>
            <span>
              Usuário
            </span>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="listaUsuarios.length>0 && uuidUnidade!=null" class="card">
      <div class="table-responsive">

        <div class="row">
          <p-table #dt [columns]="cols"
            styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
            [value]="listaUsuarios" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
            [(selection)]="unidade" [first]="first">

            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" class="alignRight"></p-sortIcon>
                </th>
                <th  style="width: 15%;" *ngIf="usuario.permissoes.administrador" class="justify-content-end">

                  <span data-toggle="tooltip" data-placement="bottom" title="Adicionar Novo Usuário">
                    <button type="button" pButton pRipple  icon="pi pi-plus" (click)="adicionarUsuario()" class="btn btn-md btn-success" style="width: 45%;">
                    </button>
                  </span>
                <div style="margin-left: 10%;display: inline;"></div>
                <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                  <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()" style="width: 45%;"
                    class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom"></button>
                  </span>

              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
              <tr [pSelectableRow]="rowData">
                <td>{{rowData.id}}</td>
                <td>{{rowData.nome}}</td>
              <td>{{rowData.email}}</td>
              <td>{{rowData.login}}</td>
              <td class="py-0 text-right" >
                <div class="d-flex justify-content-center">

                  <span data-toggle="tooltip" data-placement="bottom" title="Visualizar">
                    <button (click)="visualizarUsuario(rowData)" class="btn btn-sm btn-icon btn-info">
                      <i class="mdi mdi-eye"></i>
                    </button>
                    </span>

                <span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Editar">
                <button (click)="editarUsuario(rowData)" class="btn btn-sm btn-icon btn-primary mx-1">
                  <i class="mdi mdi-pencil"></i>
                </button>
                </span>

                <span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Excluir">
                <button (click)="removerUsuario(rowData)" class="btn btn-sm btn-danger btn-icon mx-1">
                  <i class="mdi mdi-delete"></i>
                </button>
                </span>

                <!--<span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Alterar senha de usuário">
                <button (click)="alterarSenhaUsuario(rowData)" class="btn btn-sm btn-warning btn-icon mr-2">
                    <i class="mdi mdi-lock"></i>
                  </button>
                </span>-->
                <app-input-toggle *ngIf="usuario.permissoes.administrador"  bgOffColor="bg-danger" bgColor="bg-success"  (checkedChange)="mudarStatusUsuario($event, rowData)" [checked]="rowData.status"></app-input-toggle>


                </div>
              </td>

              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length + 1">
                  Nenhum resultado foi encontrado
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
    </div>
  </section>
